<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Добавить универсальные ключи</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn class="text-none" @click="loadKeys" rounded :loading="loadingUnKeys">
        Выбрать
      </v-btn>
      <v-dialog
        v-model="universalKeyDialog"
        max-width="70%"
      >
        <v-card class="pa-4">
          <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
          <v-card-title>Выберите универсальные ключи</v-card-title>
          <v-row align="center">
            <v-col cols="6" sm="3" class="py-0">
              <v-text-field
                v-model="universalFilterName"
                label="имя"
                outlined
                dense
                hide-details
                class="input input-search pl-3"
                @keyup="(e) => e.keyCode === 13 && filterUniversalKeys()"
              />
            </v-col>
            <v-col cols="6" sm="3" class="py-0">
              <v-text-field
                v-model="universalFilterCode"
                label="код"
                outlined
                dense
                hide-details
                class="input input-search pl-3"
                @keyup="(e) => e.keyCode === 13 && filterUniversalKeys()"
              />
            </v-col>
            <v-col class="pl-6">
            <v-btn
              dark
              class="btn blue darken-3 white px-7 text-none"
              @click.prevent="filterUniversalKeys"
            >
              Поиск
            </v-btn>
            </v-col>
            <v-col class="pl-6">
            <v-checkbox
              label="Выбор всех ключей"
              class="pt-0 pb-2"
              v-if="checkboxAllSmall"
              v-model="selectedAll"
              @click="selectedAllKey()"
            >
            </v-checkbox>
            </v-col>
          </v-row>
          <v-data-table
            class="table mt-4"
            :headers="headersUniversalKey"
            :items="universalKeys"
            :options.sync="universalOptions"
            :server-items-length="universalTotalKeys"
            :footer-props="{
                'items-per-page-options': [10, 50, 100, 500, 1000, -1],
              }"
            disable-sort
          >
            <template v-slot:header.selected>
              <v-row class="ml-1">
                <v-checkbox
                  class="center"
                  v-model="selectedAll"
                  @click="selectedAllKey"
                />
              </v-row>
            </template>
            <template v-slot:item.selected="{ item }">
              <v-row class="ml-1">
                <v-checkbox
                  class="center"
                  v-model=item.check
                  @click="selectKey(item)"
                />
              </v-row>
            </template>
            <template v-slot:item.universal="{ item }">
              <span v-if="item.universal === 1">Да</span>
              <span v-else>Нет</span>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="closeDialog()"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              class="text-none"
              @click="addKey"
              :loading="loading"
              :disabled="selectUniversalKeys.length === 0"
            >
              Добавить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import watchTableOptions from '../../../mixins/watchTableOptions';

export default {
  name: 'UniversalKey',
  props: ['doorphones'],
  mixins: [watchTableOptions],
  data () {
    return {
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      universalKeyDialog: false,
      checkboxAllSmall: false,
      loadingUnKeys: false,
      loading: false,
      selectUniversalKeys: [],
      universalFilterCode: '',
      universalFilterName: '',
      universalFilterAgent: '',
      selectedAll: false,
      universalKeys: [],
      universalTotalKeys: 0,
      headersUniversalKey: [
        { text: '', value: 'selected' },
        { text: 'id', value: 'id' },
        { text: 'Имя ключа', value: 'name' },
        { text: 'Код ключа', value: 'code' },
        { text: 'Универсальный', value: 'universal' },
        { text: 'Агент', value: 'agent.user.name' },
      ],
    };
  },
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      keysAccess: 'Keys/keys',
    }),
  },
  methods: {
    ...mapActions({
      massAttachUniversalKey: 'Doorphone/massAttachUniversalKey',
      getKeys: 'Keys/getKeys',
    }),
    checkSize () {
      this.checkboxAllSmall = window.innerWidth <= 600;
    },
    selectedAllKey () {
      const removeKeysIds = [];
      this.universalKeys = this.universalKeys.map(key => {
        key.check = this.selectedAll;
        if (this.selectedAll) {
          const isSelected = this.selectUniversalKeys.some(selectedKey => selectedKey.id === key.id);
          if (!isSelected) {
            this.selectUniversalKeys.push(key);
          }
        } else {
          removeKeysIds.push(key.id);
        }
        return key;
      });
      if (!this.selectedAll) {
        this.selectUniversalKeys = this.selectUniversalKeys.filter(key => !removeKeysIds.includes(key.id));
      }
    },
    selectKey (item) {
      if (item.check) {
        this.selectUniversalKeys.push(item);
      } else {
        this.selectUniversalKeys = this.selectUniversalKeys.filter((key) => {
          return key.id !== item.id;
        });
      }
    },
    loadKeys () {
      this.loadingUnKeys = true;
      const agents = this.doorphones.reduce((uniqueAgents, doorphone) => {
        if (!uniqueAgents.includes(doorphone.agent_id)) {
          uniqueAgents.push(doorphone.agent_id);
        }
        return uniqueAgents;
      }, []);

      if (agents.length === 1) {
        this.universalFilterAgent = agents[0];
        const params = {
          pagination: 1,
          limit: this.universalOptions.itemsPerPage,
          filters: {
            universal: 1,
            agent_id: this.universalFilterAgent,
          },
        };
        this.getKeys(params)
          .then((response) => {
            this.universalKeys = response.keys.map(key => {
              key.check = false;
              return key;
            });
            this.universalTotalKeys = response.meta.total;
            this.universalKeyDialog = true;
            this.selectUniversalKeys = [];
          })
          .catch(() => {
            this.$flash_warning('Ошибка при загрузке ключей');
          })
          .finally(() => {
            this.loadingUnKeys = false;
          });
      } else {
        this.$flash_warning('Необходимо выбрать домофоны одного агента');
        this.loadingUnKeys = false;
      }
    },
    filterUniversalKeys () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      this.loading = true;
      const filters = {
        universal: 1,
        agent_id: this.universalFilterAgent,
      };

      if (this.universalFilterCode) {
        filters.code = this.universalFilterCode;
      }

      if (this.universalFilterName) {
        filters.name = this.universalFilterName;
      }

      this.getKeys({
        pagination: 1,
        page: this.universalOptions.page,
        limit: this.universalOptions.itemsPerPage,
        filters,
      })
        .then((response) => {
          this.universalKeys = response.keys.map(key => {
            key.check = this.selectUniversalKeys.some(selectedKey => selectedKey.id === key.id);
            return key;
          });
          this.universalTotalKeys = response.meta.total;
          this.selectedAll = false;
        })
        .catch(() => {
          this.$flash_warning('Не удалось обновить список ключей');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeDialog () {
      this.universalKey = [];
      this.universalKeyDialog = false;
    },
    addKey () {
      if (this.selectUniversalKeys.length > 0) {
        const selectedDoorphoneId = this.doorphones.map(doorphone => { return doorphone.id; });
        const selectedKeys = this.selectUniversalKeys.map(key => { return key.id; });
        this.loading = true;
        this.massAttachUniversalKey({
          doorphones: selectedDoorphoneId,
          keys: selectedKeys,
        })
          .then(() => {
            this.loading = false;
            this.selectUniversalKeys = [];
            this.selectedAll = false;
            this.universalKeyDialog = false;
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch(() => {
            this.$flash_warning('Не удалось добавить ключи в домофоны');
          });
      }
    },
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card__text, .v-card__title {
  word-break: normal;
}
</style>
